import { env } from "@watt/common/config/env";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";

import { createSelectors } from "./create-selectors";

interface State {
  isApertureOnly: boolean;
  /** Devtools panel sections currently expanded, kept while the panel is closed. */
  openSectionIds: string[];
}

interface Actions {
  setIsApertureOnly: (isApertureOnly: boolean) => void;
  setOpenSectionIds: (openSectionIds: string[]) => void;
}

type Store = State & Actions;

export const useDevtoolsStore = createSelectors(
  createWithEqualityFn<Store>()(
    immer(
      devtools(
        set => ({
          isApertureOnly: false,
          openSectionIds: ["settings"],
          setIsApertureOnly: isApertureOnly => {
            set({ isApertureOnly });
          },
          setOpenSectionIds: openSectionIds => {
            set({ openSectionIds });
          }
        }),
        {
          enabled:
            env.NODE_ENV === "development" && typeof window !== "undefined",
          name: "Devtools Store"
        }
      )
    ),
    shallow
  )
);
